import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';
import { Info } from 'lucide-react';

export function InfoTooltip({ text, side = 'top', className = '' }) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className={`inline-flex items-center justify-center w-4 h-4 rounded-full bg-slate-200 hover:bg-slate-300 text-slate-500 hover:text-slate-700 transition-colors ${className}`}
            data-testid="info-tooltip-trigger"
          >
            <Info className="w-2.5 h-2.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-[240px] text-xs leading-relaxed bg-slate-900 text-white border-slate-700">
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export const METRIC_TOOLTIPS = {
  baseArea: "The flat (2D) area of the roof as drawn on satellite imagery, before pitch adjustment.",
  pitch: "Roof steepness measured as inches of rise per 12 inches of horizontal run. Higher pitch = more material needed.",
  totalArea: "Actual roof surface area after pitch adjustment. This is the number you use for ordering materials.",
  squares: "Roofing industry unit. 1 square = 100 sq ft. Shingles and other materials are often sold per square.",
  perimeter: "Total length around the roof outline. Used to calculate drip edge, starter strip, and gutter estimates.",
  wasteFactor: "Extra material percentage to account for cutting, overlaps, and damage. Standard is 10% for simple roofs.",
  complexity: "Roof shape affects material waste. Complex roofs with more cuts and angles need a higher waste factor.",
  shingleBundles: "Architectural or 3-tab shingles. 3 bundles cover 1 square (100 sq ft).",
  underlayment: "Synthetic felt underlayment installed under shingles. Each roll covers approximately 4 squares.",
  decking: "4x8 plywood or OSB sheets (32 sq ft each) for roof deck replacement or repair.",
  nails: "Coil or hand-drive roofing nails, typically 1.25 inch. Weight-based for easy ordering.",
  starterStrip: "Applied along eaves and rake edges as the first course. Provides adhesive seal against wind.",
  iceWater: "Self-adhering waterproof membrane for valleys, eaves, and around roof penetrations.",
  dripEdge: "Metal flashing along roof edges that directs water into gutters. Sold in 10ft sections.",
  ridgeCap: "Specially cut shingle pieces installed along ridges and hips for a finished weatherproof seal.",
  lineMeasurements: "Valleys and ridges measured in linear feet. These are reference measurements for your records and reports — they are not added to material quantities.",
  gutterLinear: "Total gutter run along eave lines. Estimated at ~60% of roof perimeter for a typical gable roof.",
  gutterSections: "Standard 10ft gutter sections needed. Cut and joined on-site.",
  downspouts: "Vertical drain pipes carrying water from gutters to ground. One per 40ft of gutter run, minimum 2.",
  downspoutElbows: "Directional fittings for downspouts. 2 per downspout plus spares for offsets.",
  endCaps: "Sealed ends for gutter runs. Left and right caps for each open end.",
  hangers: "Mounting brackets that secure gutters to fascia board. Spaced every 3 feet.",
  gutterScrews: "Stainless steel screws for assembling gutter sections and mounting.",
  splashBlocks: "Placed at downspout base to direct water away from foundation. One per downspout.",
  gutterSealant: "Silicone sealant for seams and connections. 1 tube per ~20ft of gutter.",
};
